import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SiaTooltipDirective, SiaTranslatePipe } from '@sia/shared';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaErrorHintComponent } from '../sia-error-hint/sia-error-hint.component';
import { SiaPhoneButtonComponent } from '../sia-phone-button/sia-phone-button.component';

@Component({
  selector: 'sia-phone-box',
  templateUrl: './sia-phone-box.component.html',
  styleUrls: ['./sia-phone-box.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SiaPhoneButtonComponent,
    SiaErrorHintComponent,
    SiaTooltipDirective,
    ReactiveFormsModule,
    SiaTranslatePipe,
    MatFormField,
    FormsModule,
    MatLabel,
    MatInput,
    MatHint,
  ],
})
export class SiaPhoneBoxComponent extends SiaBaseEditorSignalComponent {
  readonly isMobile = input(false);
}
